import Image from "next/image";
import Link from "next/link";
import dynamic from "next/dynamic"; // Import dynamic for client-side rendering
import { Col, Container, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { handleImage } from "../../handlers";
import { buildWhatsAppUrl } from "../../../utils/whatsapp.mjs";

// Dynamically import ReactPlayer to avoid hydration issues
const ReactPlayer = dynamic(() => import("react-player"), { ssr: false });

export default function About({ data, page = "0", siteInfo }) {
  const { locale } = useIntl();

  const renderMedia = (media) => {
    if (!media || media.trim() === "") return null; // Check for non-empty media strings

    const isPlayableMedia = (url) => {
      const playablePatterns = [
        /(?:https?:\/\/)?(?:www\.)?(youtube\.com|youtu\.be|vimeo\.com)/i, // YouTube/Vimeo links
      ];
      return playablePatterns.some((pattern) => pattern.test(url));
    };
    if (isPlayableMedia(media)) {
      return (
        <ReactPlayer
          url={media}
          controls
          width="100%"
          height={400}
          style={{
            minHeight: "200px",
          }}
          className="video-player rounded-4 mb-3 overflow-hidden"
        />
      );
    }

    if (media.match(/\.(mp4|webm|ogg)$/i)) {
      return (
        <video
          controls
          width="100%"
          height="100%"
          className="video-player rounded-4"
        >
          <source src={handleImage(media)} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }
  };

  return (
    <div className="wrapper about w-100">
      <Container>
        <Row className="about-pic w-100 m-0 align-items-center">
          <Col xs="12" md="8" xl="6" className="px-0 img-wrapper m-auto">
            {renderMedia(data?.image || data?.youtubeLink)}
          </Col>
          <Col xs="12" md="12" xl="6" className="align-self-center info p-lg-4">
            {data?.subTitle?.[locale]?.trim() && (
              <h1 className="unique-bold text-start color-main h2">
                {data.subTitle[locale]}
              </h1>
            )}
            {data?.description?.[locale]?.trim() && (
              <p className="pt-lg-4 pt-0">{data.description[locale]}</p>
            )}
            {page !== "about" && (
              <div className="rounded-5 whatsapp">
                <Link
                  href={buildWhatsAppUrl(siteInfo?.whatsup)}
                  aria-label="whatsapp"
                >
                  <FormattedMessage id="send-whatsapp" />
                </Link>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
